// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"4d893e5f","413":"b27fac98","960":"d2f614c2","963":"2c477a60","988":"49d7ae15"}[chunkId] + ".chunk.js";
};